/*=========================================================================================
  File Name: moduleConsultationGetters.js
  Description: Consultation Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {

}
